module.exports = __webpack_public_path__ + "static/media/floral.91494118.png";